<!--
* @description  参数1
* @fileName  confirmOrder
* @author userName
* @date 2024-01-17 10:53:58
!-->
<template>
  <div id="confirmOrder" class="confirmOrder">
    <div class="confirmOrder-main">
      <div class="confirmOrder-title">
        <div class="confirmOrder-title-l">
          <span>┃</span><span>{{ showTips() }}</span>
        </div>
        <div class="confirmOrder-title-r" @click="close">CLOSE<span>✖</span></div>
      </div>
      <div class="confirmOrder-tab">
        <div class="order-information">
          <div class="order-info-l">
            <div v-if="!isUpdateRefNo" @click="eidtRefNo()">
              {{ data.refNo?data.refNo:'Enter your PO/SKU/Internal reference' }}
            </div>
            <div v-if="isUpdateRefNo"><el-input
              ref="RefNo"
              v-model="data.refNo"
              style="width: 90%;padding: 0;"
              @blur="saveRefNo"
            /></div>
            <div>{{ data.orderNo }}</div>
          </div>
          <div
            class="order-info-r"
            @mouseenter="()=>{isStatusDialog = true}"
            @mouseleave="()=>{isStatusDialog=false}"
          >
            <div class="r-one">SHIPMENT STATUS<i class="el-icon-arrow-down" /></div>
            <div :class="data.status>1&&data.status<8?'r-two2':'r-two'">{{ statusList[data.status-1] }}
            </div>
            <div class="r-three">Please complete all shipping instructions so your shipment can be processed
            </div>
            <div class="state-steps">
              <div
                v-for="(index,i) in stateList"
                :key="i"
                :class="['state-steps-default',state>i?(state==1?'state-steps-active':'state-steps-active2'):'']"
              />
            </div>
            <StatusDialog v-show="isStatusDialog&&data.status<8" ref="StatusDialog" />
          </div>
          <div class="order-info-3">
            <div>
              Conversation with Flexshipping
            </div>
            <div>
              <img
                style="width: 32px;cursor: pointer;"
                src="../../../../assets/img/client/icon_Conversation_normal@2x.png"
                @click="clickChat"
              >
            </div>
          </div>
        </div>
        <div class="order-info-steps">
          <div class="order-info-steps-l">
            <div
              v-for="item in orderInfoSteps"
              :key="item.index"
              :class="['tab-class',{'active':selectNumber == item.index}]"
              @click="clickType(item,item.index)"
            >
              {{ item.title }}
            </div>
          </div>
          <div v-if="[1].includes(selectNumber) " class="order-info-steps-r">
            <div @click="cancelShip">
              <span>Cancel shipment</span>
            </div>
            <div class="flex m24" @click="downloadOrder">
              <img src="../../../../assets/img/client/下载.png" width="16px" height="16px">
              <span>Shipment deta</span>
            </div>

          </div>
          <div v-if="[2].includes(selectNumber) " class="order-info-steps-r">
            <!--            <div>
              <span>Flexshipping Bank Details</span>
            </div> -->
            <div class="flex m24" @click="downloadBill">
              <img src="../../../../assets/img/client/下载.png" width="16px" height="16px">
              <span>Proforma Invoice</span>
            </div>

          </div>
        </div>
      </div>
      <BookingCancelled v-if="data.status==8" />
      <ActionIndex v-show="selectNumber == 0&&data.status==1" ref="ActionIndex" @finish="finish" />
      <SummaryIndex v-show="selectNumber == 1" ref="SummaryIndex" />
      <ShipmentCharges v-show="selectNumber == 2" ref="ShipmentCharges" />
      <Quote v-show="selectNumber == 3" ref="Quote" />
      <CancelShipment ref="cancelSh" @confirm="finish" />
      <ChatDialog v-if="chatVisible" ref="ChatDialog" @close="closeChat" />
    </div>

  </div>
</template>

<script>
import {
  GetSeaOrderDetail,
  UpdateRefNo,
  ExportOrderDetail
} from '../../../../api/order.js'
import {
  GetChatUserId
} from '@/api/user.js'
import { ExportBillDetail } from '@/api/user.js'
import StatusDialog from './statusDialog.vue'
import ActionIndex from './confirmOrderTab/actionRequired/actionIndex.vue'
import SummaryIndex from './confirmOrderTab/summary/summaryIndex.vue'
import ShipmentCharges from './confirmOrderTab/shipmentCharges/shipmentCharges.vue'
import Quote from './confirmOrderTab/quote/quote.vue'
import * as define from '../../../../utils/define.js'
import BookingCancelled from './bookingCancelled.vue'
import CancelShipment from './confirmOrderTab/actionRequired/cancelShipment.vue'
import ChatDialog from '@/client/home/chatBox/index.vue'
export default {
  name: 'ConfirmOrder',
  components: {
    // 组件的引用
    StatusDialog,
    ActionIndex,
    SummaryIndex,
    ShipmentCharges,
    Quote,
    BookingCancelled,
    CancelShipment,
    ChatDialog
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      stateList: 6,
      state: 1,
      orderInfoSteps: [{
        title: 'Action required',
        index: 0
      },
      {
        title: 'Summary',
        index: 1
      },
      {
        title: 'Shipment Charges',
        index: 2
      },
      {
        title: 'Quote',
        index: 3
      }
      ],
      selectNumber: 0,
      isStatusDialog: false,
      data: {},
      statusList: ['Booking Placed', 'Booking Sent to Flexshipping', 'Space Booked', 'Goods Received',
        'Departed from Port', 'Arrived at Port', 'Delivered', 'Booking cancelled'
      ],
	  isUpdateRefNo: false,
      chatVisible: false
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    downloadBill() {
      ExportBillDetail({
        orderNo: this.data.orderNo
      }).then(res => {
        if (res.code === 200) {
          this.xms.downloadFile(res.data.url)
        }
      })
    },
    downloadOrder() {
      ExportOrderDetail({
        orderNo: this.data.orderNo
      }).then(res => {
        if (res.code === 200) {
          this.xms.downloadFile(res.data.url)
        }
      })
    },
    cancelShip() {
      this.$refs.cancelSh.init(this.data)
    },
    closeChat() {
      this.chatVisible = false
    },
    clickChat(item) {
      GetChatUserId().then(res => {
        if (res.code === 200) {
          this.chatVisible = true
          this.$nextTick(() => {
            this.$refs.ChatDialog.init(null, null, res.data)
          })
        }
      })
    },
	  eidtRefNo() {
	    this.isUpdateRefNo = true
	    this.$nextTick(() => {
	      this.$refs.RefNo.focus()
	    })
	  },
	  saveRefNo() {
	    this.isUpdateRefNo = false
	    UpdateRefNo({
	      orderNo: this.data.orderNo,
	      refNo: this.data.refNo
	    }).then(res => {
	      if (res.code == 200) {
	        this.initOrder(this.data.orderNo)
	      }
	    })
	  },
    finish() {
      this.initOrder(this.data.orderNo)
    },
    init(data) {
      this.data = data
      this.state = this.data.status
      if (this.state >= 8) {
        this.state = 0
      }
      this.$nextTick(() => {
        this.$refs.ActionIndex.init(data)
        this.$refs.SummaryIndex.init(data)
        this.$refs.ShipmentCharges.init(data)
        this.$refs.Quote.init(data)
        this.$refs.StatusDialog.init(data)
        this.actionShow()
      })
    },
    initOrder(orderNo, index) {
      GetSeaOrderDetail(orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
          this.state = this.data.status
          if (this.state >= 8) {
            this.state = 0
          }
          this.data.totalAmount = this.totalAmount

          this.$refs.ActionIndex.init(this.data)
          this.$refs.SummaryIndex.init(this.data)
          this.$refs.ShipmentCharges.init(this.data)
          this.$refs.Quote.init(this.data)
          this.$refs.StatusDialog.init(this.data)
          this.actionShow()
          if (index != undefined) {
            this.selectNumber = index + 1
          }
        }
      })
    },
    actionShow() {
      if (this.data.status == 1) {
        this.orderInfoSteps = [{
          title: 'Action required',
          index: 0
        },
        {
          title: 'Summary',
          index: 1
        },
        {
          title: 'Shipment Charges',
          index: 2
        },
        {
          title: 'Quote',
          index: 3
        }
        ]
        this.selectNumber = 0
      } else {
        this.orderInfoSteps = [{
          title: 'Summary',
          index: 1
        },
        {
          title: 'Shipment Charges',
          index: 2
        },
        {
          title: 'Quote',
          index: 3
        }
        ]
        this.selectNumber = 1
      }
    },
    // 方法
    clickType(item, index) {
      this.selectNumber = index
    },
    close() {
      this.$emit('close')
    },
    showTips() {
      return this.data.status == 1 ? 'Confirm filling in order information' : 'Shipment Details'
    }
  }
}
</script>
<style scoped lang='scss'>
	.flex {
		display: flex;
		align-items: center;
	}

	.m8 {
		margin: 0 8px;
	}

	.confirmOrder-title-font {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #333333;
	}

	.confirmOrder {
		//z-index: 100;
		position: fixed;
		top: 80px;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		margin: 0;
		//background: rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.04);
		backdrop-filter: blur(8px);

		.confirmOrder-main {
			margin: 0 auto;
			width: 1200px;

			.confirmOrder-title {
				@extend .flex;
				justify-content: space-between;
				margin: 24px 0;

				.confirmOrder-title-l {
					@extend .flex;

					span:nth-of-type(1) {
						color: #E95506;
						margin-right: 12px;
					}

					span:nth-of-type(2) {
						@extend .confirmOrder-title-font;
					}
				}

				.confirmOrder-title-r {
					cursor: pointer;
					@extend .confirmOrder-title-font;

					span {
						margin-left: 10px;
						font-weight: bold;

					}
				}

			}

			.confirmOrder-tab {
				width: 1200px;
				height: 192px;
				background: #FFFFFF;
				border-radius: 8px;
				border: 1px solid rgba(170, 170, 170, 0.16);

				.order-information {
					height: 136px;
					display: flex;

					.order-info-l {
						width: 368px;
						height: 112px;
						border-right: 1px solid #DDDDDD;
						margin: 16px 24px 8px 16px;
						text-align: left;

						div:nth-of-type(1) {
							height: 40px;
							//line-height: 40px;
							padding: 10px 8px;
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;
						}

						div:nth-of-type(2) {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #777777;
							margin-left: 8px;
						}
					}
          .order-info-3 {
						width: 368px;
						height: 112px;
						border-left: 1px solid #DDDDDD;
						margin: 16px 24px 8px 16px;
						text-align: left;
						padding-left: 15px;

						div:nth-of-type(1) {
							height: 40px;
							padding: 10px 8px;
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;
						}

						div:nth-of-type(2) {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #777777;
							margin-left: 8px;
						}
					}
					.order-info-r {
						text-align: left;
						margin: 26px 0 0 8px;

						.r-one {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;
						}

						.r-two {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							color: #EF0A0A;
							margin: 10px 0 5px 0;
						}

						.r-two2 {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							color: #1DB62F;
							margin: 10px 0 5px 0;
						}

						.r-three {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #777777;
						}

						.state-steps {
							display: flex;
							margin-top: 9px;

							.state-steps-default {
								width: 56px;
								height: 8px;
								//background: #EF0A0A;
								background: rgba(170, 170, 170, 0.24);
								//border-radius: 4px 0px 0px 4px;
								margin-right: 2px;
							}

							.state-steps-default:first-child {
								border-radius: 4px 0px 0px 4px;
							}

							.state-steps-default:last-child {
								border-radius: 0px 4px 4px 0px;
							}

							.state-steps-active {
								background: #EF0A0A;
							}

							.state-steps-active2 {
								background: #1DB62F;
							}
						}
					}
				}

				.order-info-steps {
					height: 56px;
					border-top: 1px solid rgba(221, 221, 221, 0.56);
					display: flex;
					align-items: center;
          justify-content: space-between;
					margin-left: 16px;

					.tab-class {
						cursor: pointer;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						margin-right: 24px;
					}

					.active {
						// width: 133px;
						// height: 32px;
						background: rgba(233, 85, 6, 0.08);
						border-radius: 8px;
						line-height: 32px;
						text-align: center;
						color: #E95506;
						padding: 0px 8px;
					}
          .order-info-steps-l{
            display: flex;
            align-items: center;
          }
          .order-info-steps-r{
            display: flex;
            align-items: center;
            .m24{
              margin: 0 24px;
            }
            .flex{
              display: flex;
              align-items: center;
            }
            img{
              margin-right: 4px;
            }
            span{
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #027FFC;
              cursor: pointer;
            }
          }
				}
			}

		}
	}
</style>
